import { render, staticRenderFns } from "./CustomerUpgradeData.vue?vue&type=template&id=2b57ccb4&"
import script from "./CustomerUpgradeData.vue?vue&type=script&lang=js&"
export * from "./CustomerUpgradeData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUpgradeData.vue?vue&type=style&index=0&id=2b57ccb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports